import { toast } from "react-toastify"
import { ToastContent, ToastOptions } from "react-toastify/dist/types"
import clsx from "clsx"
import CrossIcon from "../assets/icons/cross-icon"
export const ApnaToast = {
    show(content: ToastContent<any>, options?: ToastOptions) {
        const { className = "", bodyClassName = "", ...rest } = options || {}
        let id = Math.random().toString()
        try {
            id = JSON.stringify(content)
        } catch (e) {
            console.error(e)
        }
        if (!toast.isActive(id))
            toast(content, {
                toastId: id,
                autoClose: 3500,
                closeOnClick: true,
                closeButton: (
                    <CrossIcon className=" !ml-[8px] self-center [&>path]:fill-[#fff]" />
                ),
                position: "bottom-center",
                className: clsx(
                    "p-4 !bg-onSurface-primary mb-24 mx-4 rounded min-h-[auto] ",
                    className
                ),
                bodyClassName: clsx("!p-0 text-[#fff] text-xs ", bodyClassName),
                ...rest,
            })
    },
}
